import React, { forwardRef, useImperativeHandle, useState } from "react";
import { DatePicker } from "@progress/kendo-react-dateinputs";

const DashbaordDateFilter = ({ filterData, onFilterChange }, ref) => {
  const initialFromDate =
    filterData.operator === "ytd" ? new Date(new Date().getFullYear(), 0, 1) : new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  const initialToDate = new Date();
  const initialDateValue = filterData.value;

  const formatDate = (date) => {
    return `date:${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  };

  const handleDateChange = (key, date) => {
    onFilterChange({ ...filterData, value: key !== "date" ? { ...filterData.value, [key]: date } : date });
  };

  useImperativeHandle(ref, () => ({
    getDateValues: () => {
      if (filterData.operator === "ytd" || filterData.operator === "mtd") {
        let tempFromDate = [filterData.field, ">=", formatDate(initialFromDate)];
        let tempToDate = [filterData.field, "<=", formatDate(initialToDate)];
        return [[tempFromDate, "AND", tempToDate]]; //is being spread in the parent;
      } else if (filterData.operator === "gte&&lte") {
        let tempFromDate = [filterData.field, ">=", formatDate(filterData.value?.startDate || initialFromDate)];
        let tempToDate = [filterData.field, "<=", formatDate(filterData.value?.endDate || initialToDate)];
        return [[tempFromDate, "AND", tempToDate]]; //is being spread in the parent;
      } else {
        return [[filterData.field, filterData.operator, formatDate(filterData.value || initialDateValue)]];
      }
    },
    getOperator: () => {
      return filterData.operator;
    },
  }));

  if (filterData.operator === "ytd" || filterData.operator === "mtd" || filterData.operator === "gte&&lte") {
    let startDate, endDate;
    if (filterData.operator === "ytd" || filterData.operator === "mtd") {
      startDate = initialFromDate;
      endDate = initialToDate;
    } else {
      startDate = filterData.value?.startDate || initialFromDate;
      endDate = filterData.value?.endDate || initialToDate;
      return (
        <div style={{ display: "flex", gap: "8px" }}>
          <DatePicker value={startDate} placeholder="From" onChange={(e) => handleDateChange("startDate", e.value)} />
          <DatePicker value={endDate} placeholder="To" onChange={(e) => handleDateChange("endDate", e.value)} />
        </div>
      );
    }
  } else {
    let dateValue;
    if (filterData?.value && typeof filterData?.value === "object") {
      if (Object.keys(filterData.value).length > 1) {
        dateValue = new Date();
      } else {
        dateValue = filterData.value;
      }
    } else {
      dateValue = initialDateValue;
    }
    return <DatePicker value={dateValue} placeholder="Pick a date" onChange={(e) => handleDateChange("date", e.value)} />;
  }
};

export default forwardRef(DashbaordDateFilter);
